import { DashboardComponent } from './dashboard/dashboard.component';
import { ActivatedRoute } from '@angular/router';
import { StatsService } from './stats.service';
import { Component, OnInit, ComponentFactoryResolver, ViewChild, OnDestroy } from '@angular/core';
import { Translation } from '../../providers/translation';
import { SessionsService } from '../sessions/sessions.service';
import { tap, first } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'stats',
  templateUrl: './stats.component.html',
  styleUrls: ['./stats.component.scss']
})
export class StatsComponent implements OnInit, OnDestroy {
  public sessions = [];
  public activeSession: string;
  public exportLinks = [];
  // Subscribe
  private subscriptions$: Subscription[] = [];

  constructor(
    private route: ActivatedRoute,
    private componentFactoryResolver: ComponentFactoryResolver,
    private statsService: StatsService,
    private sessionsService: SessionsService,
    private translate: Translation
  ) {}

  ngOnDestroy() {
    this.subscriptions$.forEach(s => s.unsubscribe());
  }

  setActive(sessionId: string) {
    this.activeSession = sessionId;
    this.exportLinks = this.sessionsService.getExports(sessionId);
  }

  ngOnInit() {
    const curLang = this.translate.lang;
    const lang$ = this.translate.translate.onLangChange.subscribe(lang => {
      if (curLang.id !== lang.lang) {
        location.reload();
      }
    });
    this.subscriptions$.push(lang$);
    const source$ = this.route.data.map(route => route.data);
    const sessions$ = tap((sessions: any) => {
      this.sessions = sessions;
      const route$ = this.route.params.subscribe(params => {
        this.setActive((params || {}).id || (this.sessions[0] || {}).id);
      });
      this.subscriptions$.push(route$);
    });
    source$.pipe(first(), sessions$).subscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/stats/stats.component.ts